import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { generateQueryString } from "@/scripts/common/util";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";

const form = document.querySelector(".filter-form");
const pageSection = document.querySelector(".page-article");

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterLink = (e) => {
  e.preventDefault();

  const url = e.delegateTarget.href;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  window.history.replaceState({}, "", form.action);

  updateResults();
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 48);
    pageSection.classList.add("is-filtered");
  } else {
    pageSection.classList.remove("is-filtered");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  if (form) {
    delegate(".filter-link", "click", handleFilterLink);
    delegate(".filter-form", "submit", handleFilterChange);
    delegate(".filter-form-clear", "click", handleFilterClear);
  }
});
